import { identify, init, initTrackPageview } from '@cbhq/client-analytics';

import { analyticsConfig } from '../../configs/analytics';
import { history } from '../history';

import { rumSetDevice } from './datadogRum';
import { getCookieInfo } from './getCookieInfo';
import { initDatadogRum } from './initDatadogRum';
import { pageKeyRegex } from './PageKey';

export function initAnalytics(): void {
  // Analytics require a unique device ID - set one if it doesn't exist.
  const cookieInfo = getCookieInfo();

  init(analyticsConfig);

  initDatadogRum();
  rumSetDevice(cookieInfo.deviceId);

  identify(cookieInfo);

  initTrackPageview({
    // Avoid pageview for blacklist pathnames
    blacklistRegex: [],
    // Add the React Router History object when platform is web
    browserHistory: history,
    // PageKey Regex Config will allow the page keys to be logged out in DD by analytics
    pageKeyRegex,
  });
}
